"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragCaretVisualizer = void 0;
var tslib_1 = require("tslib");
var document_layout_details_level_1 = require("../../../core/layout/document-layout-details-level");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var drag_caret_listener_1 = require("../../canvas/listeners/drag-caret-listener");
var base_visualizer_1 = require("./base-visualizer");
var DragCaretVisualizer = (function (_super) {
    tslib_1.__extends(DragCaretVisualizer, _super);
    function DragCaretVisualizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragCaretVisualizer.prototype.show = function (htr) {
        var pageIndex = htr.pageIndex;
        var bounds = new rectangle_1.Rectangle(htr.getLayoutX(this.control.measurer, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character), htr.getLayoutY(document_layout_details_level_1.DocumentLayoutDetailsLevel.Row), drag_caret_listener_1.DragCaretListener.CARET_WIDTH, htr.row.height - htr.row.getSpacingBefore());
        if (!this.bounds || this.pageIndex != pageIndex || !bounds.equals(this.bounds)) {
            this.pageIndex = pageIndex;
            this.bounds = bounds;
            this.raiseShow();
        }
    };
    return DragCaretVisualizer;
}(base_visualizer_1.BaseVisualizer));
exports.DragCaretVisualizer = DragCaretVisualizer;
